module.exports = "/images/vendor/flag-icon-css/flags/4x3/is.svg?2ce20c50765b6cccf87ee4b269d8c507";